import React, { useEffect, useState } from 'react';
const NAMES = ['Sarah M. from Texas', 'James R. from Florida', 'Linda P. from California', 'Robert G. from Ohio', 'Patricia T. from New York', 'Michael L. from Arizona', 'Jennifer F. from Washington', 'David C. from Colorado', 'Maria B. from Illinois', 'William H. from Georgia', 'Karen D. from Michigan', 'Richard N. from Pennsylvania', 'Susan V. from Oregon', 'Thomas S. from Virginia', 'Nancy J. from North Carolina', 'Christopher K. from Tennessee', 'Betty W. from Minnesota', 'Daniel Z. from Nevada', 'Margaret A. from Indiana', 'Paul E. from Wisconsin'];
type NotificationType = 'sale' | 'cart';
interface NotificationData {
  name: string;
  type: NotificationType;
  minutesAgo: number;
  id: number;
}
export function SaleNotifications() {
  const [notification, setNotification] = useState<NotificationData | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [usedIndices, setUsedIndices] = useState<Set<number>>(new Set());
  useEffect(() => {
    const getRandomName = () => {
      let available = NAMES.map((_, i) => i).filter(i => !usedIndices.has(i));
      if (available.length === 0) {
        setUsedIndices(new Set());
        available = NAMES.map((_, i) => i);
      }
      const idx = available[Math.floor(Math.random() * available.length)];
      setUsedIndices(prev => new Set(prev).add(idx));
      return NAMES[idx];
    };
    const showNotification = () => {
      const name = getRandomName();
      const type: NotificationType = Math.random() > 0.5 ? 'sale' : 'cart';
      const minutesAgo = Math.floor(Math.random() * 12) + 1;
      setNotification({
        name,
        type,
        minutesAgo,
        id: Date.now()
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // First notification after 5 seconds
    const initialTimer = setTimeout(showNotification, 5000);
    // Then every 25 seconds
    const interval = setInterval(showNotification, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!notification) return null;
  return <div className={`fixed bottom-[70px] left-3 z-[999] transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-268">
      <div className="bg-white border border-[#E5E5E0] shadow-lg px-4 py-3 flex items-start gap-3 max-w-[280px] rounded-sm" data-id="element-269">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#8B2500]/10 flex items-center justify-center text-[#8B2500] font-sans font-bold text-[11px]" data-id="element-270">
          {notification.name.charAt(0)}
        </div>
        <div className="min-w-0" data-id="element-271">
          <p className="text-[12px] font-bold text-[#1a1a1a] font-sans leading-tight truncate" data-id="element-272">
            {notification.name}
          </p>
          <p className="text-[11px] text-[#666] font-sans leading-tight mt-0.5" data-id="element-273">
            {notification.type === 'sale' ? 'just downloaded the guide' : 'added the guide to cart'}
          </p>
          <p className="text-[10px] text-[#999] font-sans mt-1" data-id="element-274">
            {notification.minutesAgo} min ago
          </p>
        </div>
      </div>
    </div>;
}